import type { DocumentData } from "firebase/firestore";
import BaseApi from "../core/BaseApi";
import PlanModel, { type PlanModelData } from "./PlanModel";

export default class PlansApi extends BaseApi<PlanModel, PlanModelData> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}plans`;
  }

  get store() {
    return this.stores.plansStore;
  }

  fromFirestore(res: DocumentData): PlanModel {
    return new PlanModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
